import filterConstants from '../constants';

const reportsProgressSchedule = () => ({
  id: null,
  name: null,
  type: filterConstants.FILTERS.reportsProgressSchedule,
  properties: {
    [filterConstants.PROPERTY.gantt_id]: '',
    [filterConstants.PROPERTY.portfolio_id]: '',
  },
});

export default reportsProgressSchedule;
